function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import Progress from '../progress';

var loadingSvg = require('./assets/loading.svg');

var pagePrefixCls = 'eui-loading';

var Loading = /*#__PURE__*/function (_Component) {
  _inherits(Loading, _Component);

  var _super = _createSuper(Loading);

  function Loading() {
    var _this;

    _classCallCheck(this, Loading);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "modLoadingRender", function () {
      var _this$props = _this.props,
          color = _this$props.color,
          size = _this$props.size,
          text = _this$props.text;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(pagePrefixCls, "-dasharray"),
        style: {
          width: "".concat(size || '48px'),
          height: "".concat(size || '48px')
        }
      }, /*#__PURE__*/React.createElement("svg", {
        className: "".concat(pagePrefixCls, "-dasharray-svg"),
        width: "100%",
        height: "100%",
        viewBox: "0 0 120 120"
      }, /*#__PURE__*/React.createElement("circle", {
        id: "c1",
        transform: "rotate(-90 0 0)",
        className: "".concat(pagePrefixCls, "-dasharray-one"),
        stroke: "".concat(color ? " ".concat(color) : '#cbd3db'),
        cx: "60",
        cy: "60",
        r: "52",
        strokeLinecap: "round",
        fill: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        id: "c1",
        transform: "rotate(90 0 0)",
        className: "".concat(pagePrefixCls, "-dasharray-two"),
        stroke: "".concat(color ? " ".concat(color) : '#cbd3db'),
        cx: "60",
        cy: "60",
        r: "52",
        strokeLinecap: "round",
        fill: "none"
      }))), /*#__PURE__*/React.createElement("p", {
        className: "".concat(pagePrefixCls, "-text")
      }, text || '数据加载中', /*#__PURE__*/React.createElement("span", {
        className: "".concat(pagePrefixCls, "-dot")
      }, "\xB7\xB7\xB7")));
    });

    _defineProperty(_assertThisInitialized(_this), "pageLoadingRender", function () {
      var _this$props2 = _this.props,
          color = _this$props2.color,
          size = _this$props2.size,
          text = _this$props2.text;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(pagePrefixCls, "-circle"),
        style: {
          width: "".concat(size || '120px'),
          height: "".concat(size || '120px')
        }
      }, /*#__PURE__*/React.createElement("svg", {
        className: "".concat(pagePrefixCls, "-circle-svg"),
        width: "100%",
        height: "100%",
        viewBox: "0 0 120 120"
      }, /*#__PURE__*/React.createElement("circle", {
        id: "c1",
        className: "".concat(pagePrefixCls, "-circle-one"),
        stroke: "".concat(color ? " ".concat(color) : '#cbd3db'),
        cx: "60",
        cy: "60",
        r: "52",
        strokeLinecap: "round",
        fill: "none",
        strokeWidth: "16"
      }), /*#__PURE__*/React.createElement("circle", {
        id: "c2",
        className: "".concat(pagePrefixCls, "-circle-two"),
        cx: "82",
        cy: "60",
        r: "10",
        strokeLinecap: "round",
        fill: "".concat(color ? " ".concat(color) : '#cbd3db')
      }))), /*#__PURE__*/React.createElement("p", {
        className: "".concat(pagePrefixCls, "-text")
      }, text || '数据加载中', /*#__PURE__*/React.createElement("span", {
        className: "".concat(pagePrefixCls, "-dot")
      }, "\xB7\xB7\xB7")));
    });

    _defineProperty(_assertThisInitialized(_this), "funLoadingRender", function () {
      var _this$props3 = _this.props,
          text = _this$props3.text,
          data = _this$props3.data;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(pagePrefixCls, "-lottie")
      }, /*#__PURE__*/React.createElement("img", {
        className: "".concat(pagePrefixCls, "-lottie-svg"),
        src: loadingSvg,
        alt: ""
      }), /*#__PURE__*/React.createElement(Progress, {
        percent: data,
        status: "loading",
        showInfo: false
      }), /*#__PURE__*/React.createElement("p", {
        className: "".concat(pagePrefixCls, "-text")
      }, text || '数据加载中', /*#__PURE__*/React.createElement("span", {
        className: "".concat(pagePrefixCls, "-dot")
      }, "\xB7\xB7\xB7")));
    });

    return _this;
  }

  _createClass(Loading, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          type = _this$props4.type,
          className = _this$props4.className;
      var loadingRender = null;

      if (type === 'page') {
        loadingRender = this.pageLoadingRender();
      } else if (type === 'mod') {
        loadingRender = this.modLoadingRender();
      } else if (type === 'funloading') {
        loadingRender = this.funLoadingRender();
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(pagePrefixCls, " ").concat(className ? " ".concat(className) : '', " ").concat(type ? " ".concat(pagePrefixCls, "--").concat(type) : '')
      }, loadingRender);
    }
  }]);

  return Loading;
}(Component);

export default Loading; // 使用方法

/*
type: mod | page，mod是模块数据加载/page是页面级别加载
color：默认：#0081ef
size: 默认：mod 54px  page 120px
<Loading type="mod" color="#f00" size="100px"/>

*/